import { ContentBlockDefinition } from '@/core/block-registry';

export const BlockPreviewProps = {
   id: {
      type: String,
      required: true,
   },
   name: {
      type: String,
      default: '',
   },
   isSelected: {
      type: Boolean,
      default: true,
   },
   isRemovable: {
      type: Boolean,
      default: false,
   },
   blockDefinition: {
      type: Object as PropType<ContentBlockDefinition>,
      required: true,
      default: () => ({}),
   },
   data: {
      type: Object,
      required: true,
      default: () => ({}),
   },
} as const;

export interface BlockPreviewEmits {
   (e: 'onSelect', id: string): void;
   (e: 'onRemove', id: string): void;
}
